import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class EadPlataformaService {
    HttpAdapter = new HttpAdapter();
    baseUrlUsers = `${publicSettings.aws.baseUrls.usersManagement}/users`;
    constructor() {}

    /**
     * @public
     * Busca a url de autenticacao
     * @param {String} email
     */
    async authentication(email, accountingId) {
        let response = null;
        try {
            response = await this.HttpAdapter.call(
                `${this.baseUrlUsers}/ead/authentication`,
                {
                    email,
                    accountingId
                }
            );

            return response?.link;
        } catch (error) {
            console.error(error);
            response = false;
        }
    }
}
